import { render } from "./NewProjectModalComponent.vue?vue&type=template&id=66655a78"
import script from "./NewProjectModalComponent.vue?vue&type=script&lang=js"
export * from "./NewProjectModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__